import { getVB6SiteOrigin } from "functions/v1/navigation/utilitiesFunctions";
import { SetGlobalLegacyLoadingGifContext } from "GlobalContextProviders";
import { useContext } from "react";

// This API component comes from here: https://betterprogramming.pub/learn-to-create-your-own-usefetch-react-hook-9cc31b038e53
const useRedirectToB2GLegacy = () => {
  const setLoading = useContext(SetGlobalLegacyLoadingGifContext);

  const redirectToB2GLegacy = (path: string, e: React.MouseEvent<HTMLAnchorElement> | undefined = undefined, addOrigin = true, milisecondDelay = 0) => {
    // Prevent default
    if (e != undefined)
      e.preventDefault(); // Prevent default navigation for now

    // Turn on the legacy loading gif
    if (setLoading != undefined)
      setLoading(true);

    // Do the redirect
    setTimeout(function () { // Built in optional delay
      window.location.href = (addOrigin ? getVB6SiteOrigin() : "") + path;
    }, milisecondDelay);
  }

  return redirectToB2GLegacy;
};
export default useRedirectToB2GLegacy;